<template lang="pug">
  .product-list
    .main-area(v-if="areas.main && areas.main.length")
      section(
        v-for="(section, index) in areas.main"
        :key="section.id"
        :class="section.key"
        v-if="isAllowed(section.key, 'main')"
      )
        CategoryProducts(v-if="section.key === 'categoryproducts'" :section="section" default-orientation="horizontal")
        Post.container.mx-auto(v-if="section.key === 'post'" :section="section")
</template>

<script>
import Page from '@/views/Page';

import CategoryProducts from '@/extensions/shop/components/CategoryProducts';
import Post from '@/components/Post';

export default {
    name: 'Products',
    extends: Page,
    components: {
        CategoryProducts,
        Post
    },
    methods: {
        isAllowed(key, area = 'main') {
            switch (area) {
                // case 'header':
                //   return ['banner', 'slider'].includes(key);

                case 'main':
                default:
                    return ['categoryproducts', 'post'].includes(key);
            }
        }
    }
};
</script>

<style lang="sass" scoped>
section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
.product-list
  display: flex
  flex-direction: column
  .main-area, section
    display: flex
    flex-direction: column
    flex-grow: 1
</style>
